import React, { useState, useEffect, useContext } from "react";
import WithholdingTax from "./WithholdingTax";
import MortgageTax from "./MortgageTax";
import TransferTax from "./TransferTax";
import { getRequest } from "../../../helpers/ApiHelpers";
import { StateContext } from "../../State";
import { withRouter } from "react-router-dom";

function Taxes({ match: { params } }) {
  const { selectedState } = useContext(StateContext);
  const effectiveState = selectedState || +params.state;
 
  const [state, setState] = useState({
    withholdingTax: {},
    mortgageTax: {},
    transferTax: {},
    initialLoading: true
  });
  

  async function getTransferTaxByState(stateId) {
    const result = await getRequest("/tax/getTransferTaxByState", {
      stateId
    });
    if (result.success) {
      setState(state => ({
        ...state,
        transferTax: result.data
      }));
    }
  }

  async function getMortgageTaxByState(stateId) {
    const result = await getRequest("/tax/getMortgageTaxByState", {
      stateId
    });
    if (result.success) {
      setState(state => ({
        ...state,
        mortgageTax: result.data
      }));
    }
  }

  async function getWithholdingTaxByState(stateId) {
    const result = await getRequest("/tax/getWithholdingTaxByState", {
      stateId
    });
    if (result.success) {
      setState(state => ({
        ...state,
        withholdingTax: result.data
      }));
    }
  }

  useEffect(() => {
    if (effectiveState) {
      getTransferTaxByState(effectiveState);
      getWithholdingTaxByState(effectiveState);
      getMortgageTaxByState(effectiveState);
      setState(s => ({
        ...s,
        initialLoading: false
      }));
    }
  }, [effectiveState]);

  if (!effectiveState) {
    return <div />;
  }

  return (
    <React.Fragment>
      <WithholdingTax
        tax={state.withholdingTax}
        editRoute={`/rates/states/${effectiveState}/edit-withholding-tax`}
      />
      <MortgageTax
        tax={state.mortgageTax}
        editRoute={`/rates/states/${effectiveState}/edit-mortgage-tax`}
      />
      <TransferTax
        tax={state.transferTax}
        editRoute={`/rates/states/${effectiveState}/edit-transfer-tax`}
      />
    </React.Fragment>
  );
}

export default withRouter(Taxes);
